<template>
  <div>
    <base-button block type="primary" class="m-0" @click="modal = true" :disabled="creationDisabled">
      {{ $t('ptMappings.create.btnLabel') }}
    </base-button>

    <modal :show.sync="modal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('ptMappings.create.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('ptMappings.create.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('ptMappings.details.operator_id') }}</label>
            <div class="col-sm-9">
              <base-input
                :error="getError('operator_id')">
                <el-select
                  name="operator_id"
                  data-vv-as="'operator_id'"
                  class="select-primary"
                  v-validate="modelValidations.required"
                  v-model="formDetails.operator_id">
                  <el-option
                    v-for="option in operators"
                    class="select-primary"
                    :value="option.id"
                    :label="option.id"
                    :key="option.id">
                  </el-option>
                </el-select>
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('ptMappings.form.garage_number') }}</label>
            <div class="col-md-9">
              <base-input
                data-vv-as="'garage_number'"
                name="garage_number"
                v-validate="modelValidations.required"
                :error="getError('garage_number')"
                v-model="formDetails.garage_number"
                step="0.01"/>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('ptMappings.form.mapping_id') }}</label>
            <div class="col-md-9">
              <base-input
                data-vv-as="'mapping_id'"
                name="mapping_id"
                v-validate="modelValidations.mappingLength"
                :error="getError('mapping_id')"
                v-model="formDetails.mapping_id"
                step="0.01"/>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('ptMappings.details.vehicle_type') }}</label>
            <div class="col-sm-9">
              <base-input
                :error="getError('vehicle_type')">
                <el-select
                  name="vehicle_type"
                  data-vv-as="'vehicle_type'"
                  class="select-primary"
                  v-validate="modelValidations.required"
                  v-model="formDetails.vehicle_type">
                  <el-option
                    v-for="option in vehicleTypes"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="option">
                  </el-option>
                </el-select>
              </base-input>
            </div>
          </div>

          <div class="text-center">
            <base-button
              type="primary"
              :loading="updating"
              class="my-4"
              native-type="submit"
            >{{ $t('ptMappings.create.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: 'new-pt-mapping-btn',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert
  },
  props: {
    creationDisabled: {
      type: Boolean,
    },
    operators: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      modal: false,
      alert: false,
      loading: false,
      formDetails: {
        operator_id: '',
        garage_number: '',
        mapping_id: '',
        vehicle_type: ''
      },
      modelValidations: {
        required: {
          required: true
        },
        mappingLength: {
          min: 3,
          required: true
        }
      }
    }
  },

  computed: {
    ...mapState({
      updating: state => state.pt_mapping.updating,
      error: state => state.pt_mapping.error,
      vehicleTypes: state => state.pt_mapping.vehicleTypes,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    }
  },
  methods: {
    ...mapActions(['CreatePTMapping', 'LoadPTMappings']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.create()
        }
      });
    },
    create: function () {
      let payload = {
        operator_id: this.formDetails.operator_id,
        garage_number: this.formDetails.garage_number,
        mapping_id: this.formDetails.mapping_id,
        vehicle_type: this.formDetails.vehicle_type
      }

      this.CreatePTMapping(payload).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.$notify({
            type: 'success',
            message: this.$t('ptMappings.create.createdNotification', {
              operator_id: payload.operator_id,
              garage_number: payload.garage_number,
              mapping_id: payload.mapping_id,
              vehicle_type: payload.vehicle_type,
            }),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.LoadPTMappings();
          this.resetForm();
        }
      });
    },
    resetForm: function () {
      // closing dialog
      this.modal = false;

      // resetting alerts
      this.alert = false;

      // resetting form
      this.formDetails = {
        garage_number: '',
        mapping_id: '',
        vehicle_type: ''
      };

      // reset validation errors
      this.$validator.reset()
    }
  }
}
</script>
